// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kb-history-header {
  margin-bottom: 16px;
}

.kb-history-header h4 {
  margin: 4px 0 0;
}

.kb-revision-view {
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 16px;
}

.kb-revision-view-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.kb-revision-view-header h5 {
  margin: 0;
}

.kb-revision-content {
  line-height: 1.7;
  border-top: 1px solid #eee;
  padding-top: 12px;
}
`, "",{"version":3,"sources":["webpack://./src/app/knowledge-base-module/components/kb-revision-history/kb-revision-history.component.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;AACnB","sourcesContent":[".kb-history-header {\n  margin-bottom: 16px;\n}\n\n.kb-history-header h4 {\n  margin: 4px 0 0;\n}\n\n.kb-revision-view {\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  padding: 16px;\n}\n\n.kb-revision-view-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 12px;\n}\n\n.kb-revision-view-header h5 {\n  margin: 0;\n}\n\n.kb-revision-content {\n  line-height: 1.7;\n  border-top: 1px solid #eee;\n  padding-top: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
